var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h4',[_vm._v("密码"+_vm._s(_vm.msg))]),_c('h5',[_vm._v("传值"+_vm._s(_vm.childValue))]),_c('button',{on:{"click":_vm.childClick}},[_vm._v("上传到父组件")])])}
var staticRenderFns = []

export { render, staticRenderFns }